export default __webpack_public_path__ + "static/media/kc3.3110ee75.png";